import { render, staticRenderFns } from "./ModalAjouter.vue?vue&type=template&id=2b232dc2&scoped=true&"
import script from "./ModalAjouter.vue?vue&type=script&lang=js&"
export * from "./ModalAjouter.vue?vue&type=script&lang=js&"
import style0 from "./ModalAjouter.vue?vue&type=style&index=0&id=2b232dc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b232dc2",
  null
  
)

export default component.exports